export function roomInvitationUrl(origin, roomCode) {
  if (typeof roomCode !== 'string' || !/^[A-Z0-9]{6}$/.test(roomCode)) throw Error('A current room code is required.');
  const base = new URL(origin);
  if (!['https:','http:'].includes(base.protocol) || base.username || base.password || base.search || base.hash || !['','/'].includes(base.pathname)) throw Error('A valid room website origin is required.');
  const target = new URL('/',base.origin);
  target.searchParams.set('join',roomCode);
  return target.href;
}
